module.exports = __webpack_public_path__ + "img/strategy-swap.cc9136f9.svg";